/* global google */
import React from "react";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  Marker,
  DirectionsRenderer,
} from "react-google-maps";
import { connect } from "react-redux";
import MapIcon from "../../../assets/images/UserManagement/map-pin.svg";
import EndIcon from "../../../assets/images/UserManagement/user-map-icon.svg";
import { get_distance_matrix } from "../../../store/actions/distanceAction";

const icons = [EndIcon, MapIcon];
const polyIcon = [
  {
    icon: {
      path: "M 0,-1 0,1",
      strokeOpacity: 1,
      strokeColor: "#3B6897",
      fillColor: "#3B6897",
      scale: 4,
    },
    offset: "0",
    repeat: "20px",
  },
];

class MapDirectionsRenderer extends React.Component {
  state = {
    directions: null,
    error: null,
    polyline: {
      strokeOpacity: 1,
      strokeColor: "#3B6897",
      strokeWeight: 4,
    },
  };

  componentDidMount() {
    const { places, travelMode } = this.props;
    const waypoints = places.map((p) => ({
      location: { lat: p.latitude, lng: p.longitude },
      stopover: true,
    }));
    const origin = waypoints.shift().location;
    const destination = waypoints.pop().location;
    const directionsService = new google.maps.DirectionsService();
    const distance = new google.maps.DistanceMatrixService();
    let dest = `${places[1].latitude},${places[1].longitude}`;
    let org = `${places[0].latitude},${places[0].longitude}`;
    distance.getDistanceMatrix(
      { destinations: [dest], origins: [org], travelMode: travelMode },
      (res, status) => {
        if (status == "OK") {
          if (res?.rows[0]?.elements[0]?.distance?.text.split(" ")[0] < 1) {
            this.setState({ polyline: { strokeOpacity: 0, icons: polyIcon } })
          }
        }
        this.props.get_distance_matrix(res);
      }
    );
    directionsService.route(
      {
        origin: origin,
        destination: destination,
        travelMode: travelMode,
        waypoints: waypoints,
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          this.setState({
            directions: result,
          });
        } else {
          this.setState({ error: result });
        }
      }
    );
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.places) !== JSON.stringify(this.props.places)) {
      const { places, travelMode } = this.props;
      const waypoints = places.map((p) => ({
        location: { lat: p.latitude, lng: p.longitude },
        stopover: true,
      }));
      const origin = waypoints.shift().location;
      const destination = waypoints.pop().location;
      const directionsService = new google.maps.DirectionsService();
      const distance = new google.maps.DistanceMatrixService();
      let dest = `${places[1].latitude},${places[1].longitude}`;
      let org = `${places[0].latitude},${places[0].longitude}`;
      distance.getDistanceMatrix(
        { destinations: [dest], origins: [org], travelMode: travelMode },
        (res, status) => {
          if (status === "OK") {
            if (res.rows[0].elements[0].distance.text.split(" ")[0] < 1) {
              this.setState({ polyline: { strokeOpacity: 0, icons: polyIcon } });
            }
          }
          this.props.get_distance_matrix(res);
        }
      );
      directionsService.route(
        {
          origin: origin,
          destination: destination,
          travelMode: travelMode,
          waypoints: waypoints,
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            this.setState({
              directions: result,
            });
          } else {
            this.setState({ error: result });
          }
        }
      );
    }
  }

  render() {
    // if (this.state.error) {
    //   return <h1>{this.state.error}</h1>;
    // }
    return (
      this.state.directions && (
        <DirectionsRenderer
          directions={this.state.directions}
          options={{
            suppressMarkers: true,
            polylineOptions: this.state.polyline,
          }}
        />
      )
    );
  }
}

const Map = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap>
      {props.markers.map((marker, index) => {
        const position = { lat: marker.latitude, lng: marker.longitude };
        return <Marker key={index} position={position} icon={icons[index]} />;
      })}
      <MapDirectionsRenderer
        places={props.markers}
        travelMode={props.travelMode === "Driving" ? google.maps.TravelMode.DRIVING
          : props.travelMode === "Walking" ? google.maps.TravelMode.WALKING
            : props.travelMode === "Bicycling" ? google.maps.TravelMode.BICYCLING
              : props.travelMode === "Transit" ? google.maps.TravelMode.TRANSIT
                : google.maps.TravelMode.DRIVING}
        get_distance_matrix={props.get_distance_matrix}
      />
    </GoogleMap>
  ))
);

export default connect(null, { get_distance_matrix })(Map);
